import React from "react";

export default class DisappearingSuccess extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: true,
      hidden: false,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ visible: false }, () => {
        setTimeout(() => {
          this.setState({ hidden: true }, () => {
            if (typeof this.props.onHide === "function") {
              this.props.onHide();
            }
          });
        }, 500);
      });
    }, this.props.timeout || 5000);
  }

  render() {
    if (this.state.hidden) {
      return null;
    }

    return (
      <div
        className={
          "disappearing-success " +
          (this.state.visible === true ? "visible" : "hidden")
        }
      >
        {this.props.children}
      </div>
    );
  }
}
